// extracted by mini-css-extract-plugin
export default {"closeButton":"close-button-module--closeButton--89239"};